<div class="Container__wrapper">
    <div class="container">
        <ng-content></ng-content>
    </div>
</div>